import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideClientHydration } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { InterceptorService } from './app/services/interceptor.service';
import { WINDOW_PROVIDERS } from './app/services/window.service';
import { SeoService } from './app/services/seo.service';
import { DynamicScriptLoaderService } from './app/services/dynamic-script-loader.service';
import { CookieService } from 'ngx-cookie-service';
import { JsonLdService } from './app/services/json-ld.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes'; // Import your routes
import { provideNgxStripe } from 'ngx-stripe';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      ReactiveFormsModule,
      BsDatepickerModule.forRoot(),
      NgxDaterangepickerMd.forRoot()
    ),
    provideClientHydration(),
    provideNgxStripe(environment.STRIPE_API_KEY),
    provideAnimations(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    WINDOW_PROVIDERS,
    InterceptorService,
    SeoService,
    DynamicScriptLoaderService,
    CookieService,
    JsonLdService,
  ]
}).catch(err => console.error(err));